import React from 'react';
import { siteData } from '../mockData';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-end">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${siteData.images.heroBackground})`
        }}>

        <div className="absolute inset-0 bg-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="flex justify-end">
          <div className="text-right max-w-xl">
            {/* Logo on Hero */}
            <div className="mb-8 flex justify-end">
              <div className="flex items-center space-x-3 text-white">
                <img
                  src="/me-logo-white.png"
                  alt="Mazen El-Majzoub Real Estate logo"
                  width="48"
                  height="48"
                  className="h-12 w-auto"
                />
                <div className="text-right">
                  <div className="text-xl font-semibold tracking-wide">MAZEN EL-MAJZOUB</div>
                  <div className="text-xs tracking-widest">REDEFINING EXCELLENCE</div>
                </div>
              </div>
            </div>

            {/* Hero Text */}
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-6">
              Redefining<br />
              excellence in<br />
              real estate
            </h1>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>);

};

export default HeroSection;